import React from 'react';

import {
  MoreHoriz as BaseMoreHorizIcon,
  MoreVert as BaseMoreVertIcon,
  ArrowForwardIos as BaseArrowForwardIosIcon
} from '@mui/icons-material';
import {
  IconButton,
  Menu,
  MenuItem,
  Box as MuiBox,
  styled
} from '@mui/material';
import _ from 'lodash';



const MoreHorizIcon = styled(BaseMoreHorizIcon)({
  fontSize: 16
});

const MoreVertIcon = styled(BaseMoreVertIcon)({
  fontSize: 16
});

const ArrowForwardIosIcon = styled(BaseArrowForwardIosIcon)(({ theme }) => ({
  marginLeft: theme.spacing(5),
  fontSize: 12,
  color: '#87ACB9'
}));

const Box = styled(MuiBox)({
  display: 'flex',
  alignItems: 'center'
});



export interface IActionOption {
  type: 'action';
  label: string;
  isHidden?: boolean;
  fnAction: () => void;
}

export interface INestedOptionsOption {
  type: 'nestedOptions';
  label: string;
  isHidden?: boolean;
  options: IMenuOption[];
}

export type IMenuOption = IActionOption | INestedOptionsOption;

export interface IProps {
  options: IMenuOption[];
  triggerVariant?: 'horiz' | 'vert';
  iconStyle?: React.CSSProperties;
}

export const FC: React.FC<IProps> = props => {
  const [isOpen, setIsOpen] = React.useState(false);
  const refAnchor = React.useRef<HTMLButtonElement>(null);

  const [derivedOptions, setDerivedOptions] = React.useState<IMenuOption[]>(props.options);

  React.useEffect(() => {
    setDerivedOptions(props.options);
  }, [props.options]);

  const visibleOptions = React.useMemo(() =>
    _.filter(derivedOptions, opt => !opt.isHidden), [
    derivedOptions
  ]);



  return (
    <>
      <IconButton
        tabIndex={-1}
        ref={refAnchor}
        onClick={ev => {
          ev.stopPropagation();
          ev.preventDefault();
          setIsOpen(!isOpen);
        }}>
        {props.triggerVariant === 'horiz' ? (
          <MoreHorizIcon style={props.iconStyle} />

        ) : (
          <MoreVertIcon style={props.iconStyle}/>

        )}
      </IconButton>

      {isOpen &&
        <Menu
          anchorEl={refAnchor.current}
          open={isOpen}
          onClose={() => {
            setIsOpen(false);
            setDerivedOptions(props.options);
          }}>
          {_.map(visibleOptions, (opt, index) => (
            <MenuItem
              key={index}
              onClick={ev => {
                ev.stopPropagation();
                ev.preventDefault();
                if (opt.type === 'action') {
                  opt.fnAction();
                  setIsOpen(false);
                } else {
                  setDerivedOptions(opt.options);
                }
              }}>
              {opt.label !== 'Move to column' ? (
                opt.label

              ) : (
                <Box>
                  {opt.label}

                  <ArrowForwardIosIcon />
                </Box>

              )}
            </MenuItem>
          ))}
        </Menu>
      }
    </>
  );
};
